"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StartAutoLockMonitoringMsg = exports.UpdateAutoLockAccountDurationMsg = exports.GetAutoLockAccountDurationMsg = void 0;
const router_1 = require("@keplr-wallet/router");
const constants_1 = require("./constants");
class GetAutoLockAccountDurationMsg extends router_1.Message {
    static type() {
        return "get-auto-lock-account-duration";
    }
    constructor() {
        super();
    }
    validateBasic() {
        // noop
    }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return GetAutoLockAccountDurationMsg.type();
    }
}
exports.GetAutoLockAccountDurationMsg = GetAutoLockAccountDurationMsg;
class UpdateAutoLockAccountDurationMsg extends router_1.Message {
    constructor(duration) {
        super();
        this.duration = duration;
    }
    static type() {
        return "update-auto-lock-account-duration";
    }
    validateBasic() {
        if (this.duration < 0) {
            throw new router_1.KeplrError("auto-lock-account", 101, "duration cannot be set to a negative number.");
        }
    }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return UpdateAutoLockAccountDurationMsg.type();
    }
}
exports.UpdateAutoLockAccountDurationMsg = UpdateAutoLockAccountDurationMsg;
class StartAutoLockMonitoringMsg extends router_1.Message {
    static type() {
        return "start-auto-lock-monitoring";
    }
    constructor() {
        super();
    }
    validateBasic() {
        // noop
    }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return StartAutoLockMonitoringMsg.type();
    }
}
exports.StartAutoLockMonitoringMsg = StartAutoLockMonitoringMsg;
//# sourceMappingURL=messages.js.map